import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/LoginPage';
import Menu from './components/MenuPage';
import TutorCrud from './components/TutorCrud';
import PacienteCrud from './components/Paciente';
import ExameForm from './components/ExameForm';
import PrivateRoute from './components/PrivateRoute';
import ListaExames from './components/ListaExames';
const App = () => {
  return (
    <Router>
      <Routes>
        {/* Página de Login */}
        <Route path="/" element={<Login />} />

        {/* Página Principal com Menu */}
        <Route path="/menu" 
        element={
          <PrivateRoute>
            <Menu />
          </PrivateRoute>
        }
        
         />

        {/* CRUD de Tutor */}
        <Route path="/tutor"
        
         element={
          <PrivateRoute>
            <TutorCrud />
          </PrivateRoute>
         }
          />
        <Route path="/paciente" element={
          <PrivateRoute>
            <PacienteCrud />
          </PrivateRoute>
         } />

          <Route path="/exame" element={
          <PrivateRoute>
            <ExameForm />
          </PrivateRoute>
         } />
      <Route path="/consutarexames" element={
          <PrivateRoute>
            <ListaExames />
          </PrivateRoute>
         } />

      </Routes>
    </Router>
  );
};

export default App;
